module.exports = __webpack_public_path__ + "static/media/devices.8f4d5c77.webp";